import { useEffect } from 'react';
import { getCable } from '../lib/cable';
// Specific hooks for different channels using shared CableClient
export function usePodStatusWebSocket(onUpdate?: (data: any) => void) {
  useEffect(() => {
    const cable = getCable()
    const unsubscribe = cable.subscribe({ channel: 'PodStatusChannel' }, (data) => {
      if (data?.type === 'pod_status_update') onUpdate?.(data.payload)
    })
    return () => unsubscribe()
  }, [onUpdate])
}

export function useStreamMetricsWebSocket(streamId: string, onUpdate?: (metrics: any) => void) {
  useEffect(() => {
    if (!streamId) return
    const cable = getCable()
    const unsubscribe = cable.subscribe({ channel: 'StreamMetricsChannel', stream_id: streamId }, (data) => {
      if (data?.type === 'stream_metrics' && data.stream_id === streamId) onUpdate?.(data.metrics)
    })
    return () => unsubscribe()
  }, [streamId, onUpdate])
}

export function useStreamStatusWebSocket(streamId: string, onUpdate?: (data: any) => void) {
  useEffect(() => {
    if (!streamId) return
    const cable = getCable()
    const unsubscribe = cable.subscribe({ channel: 'StreamStatusChannel', stream_id: streamId }, (data) => {
      if (data?.type === 'status_update' || data?.type === 'error') onUpdate?.(data)
    })
    return () => unsubscribe()
  }, [streamId, onUpdate])
}

export function useStreamsWebSocket(onUpsert?: (stream: any) => void, onRemove?: (streamId: string) => void) {
  useEffect(() => {
    const cable = getCable()
    const unsubscribe = cable.subscribe({ channel: 'StreamsChannel' }, (data) => {
      if (data?.type === 'stream_upsert' && data.stream) onUpsert?.(data.stream)
      if (data?.type === 'stream_remove' && data.stream_id) onRemove?.(data.stream_id)
    })
    return () => unsubscribe()
  }, [onUpsert, onRemove])
}
